"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TalentPoolWithCandidateCountSchema = exports.TalentPoolMemberSchema = exports.TalentPoolSchema = void 0;
const zod_1 = require("zod");
const shared_1 = require("../shared");
exports.TalentPoolSchema = zod_1.z.object({
    id: shared_1.UUIDSchema,
    companyId: shared_1.UUIDSchema,
    name: zod_1.z.string(),
    createdAt: shared_1.ISODateTimeSchema,
    deletedAt: shared_1.ISODateTimeSchema.nullable(),
    updatedAt: shared_1.ISODateTimeSchema,
});
exports.TalentPoolMemberSchema = zod_1.z.object({
    candidateId: shared_1.UUIDSchema,
    poolId: shared_1.UUIDSchema,
    createdAt: shared_1.ISODateTimeSchema,
    deletedAt: shared_1.ISODateTimeSchema.nullable(),
    updatedAt: shared_1.ISODateTimeSchema,
});
exports.TalentPoolWithCandidateCountSchema = exports.TalentPoolSchema.extend({
    candidateCount: zod_1.z.number().int().min(0),
});
